export default {
  NETWORK_ERROR: "Network Error",
  NOT_AUTHORIZED: "Not authorized",
  MALFORMED_RESPONSE: "Malformed API response for call on: ",
  NO_SUCCESS_RESPONSE: "Didn't received SUCCESS status response on calling: ",
  DEFAULT_ERROR: "DEFAULT_ERROR"
};
